import gql from 'graphql-tag'

export default gql`
  mutation addToCart($cartInfo: CartInfo!) {
    addToCart(cartInfo: $cartInfo) {
      cart_id
    }
  }
`
